'use client';

import { Flex } from '@coolblue-development/freddy';
import {
  filterSeparateColorDiscriminant,
  getProductsWithCurrentColor
} from '@utils/collectionUtils';
import { discriminantValuesWithProducts } from '@utils/collectionUtils/shouldShowCollection';
import { Fragment } from 'react';

import {
  type Collection,
  CollectionType,
  PresentationFormat,
  type Product,
  Variant
} from '../Collection.types';
import { CollectionColorPicker } from '../Shared';
import { DropdownCollection } from './DropdownCollection';

type DropdownCollectionMobileProps = {
  collection: Collection;
  onProductClick?: (product: Product | null) => void;
  selectedProductId?: number;
};

export const DropdownCollectionMobile = ({
  collection,
  onProductClick,
  selectedProductId
}: DropdownCollectionMobileProps) => {
  const { isShowingPriceDifference } = collection.attributes;

  const productsWithCurrentColor = getProductsWithCurrentColor(collection, selectedProductId);

  return (
    <Flex gap={400} direction='column'>
      {collection.discriminants.map((discriminant, discriminantIndex) => {
        const mappedDiscriminant =
          discriminant.presentationFormat === PresentationFormat.CARDS_WITH_IMAGES
            ? filterSeparateColorDiscriminant(collection, discriminant, selectedProductId)
            : discriminant;

        if (discriminantValuesWithProducts(mappedDiscriminant.values).length <= 1) {
          return <Fragment key={discriminantIndex} />;
        }

        if (discriminant.presentationFormat === PresentationFormat.CARDS_WITH_IMAGES) {
          return (
            <CollectionColorPicker
              key={`color-${discriminantIndex}-${mappedDiscriminant.values.length}`}
              discriminant={mappedDiscriminant}
              index={discriminantIndex}
              onProductClick={onProductClick}
              variant={Variant.MOBILE}
              selectedProductId={selectedProductId}
              collectionType={CollectionType.DROPDOWN}
              colorLabel={mappedDiscriminant.displayName}
            />
          );
        } else {
          return (
            <DropdownCollection
              key={mappedDiscriminant.id}
              discriminant={mappedDiscriminant}
              shouldShowPriceDifference={isShowingPriceDifference}
              variant={Variant.MOBILE}
              onProductClick={onProductClick}
              productsWithCurrentColor={productsWithCurrentColor}
            />
          );
        }
      })}
    </Flex>
  );
};
